<template>
    <footer>

       <section id="bottom-navigation" class="block fixed inset-x-0 bottom-0 z-10 shadow"
       :class="{'my-main-footer': isPinkStyle , 'my-light-footer': !isPinkStyle}">
       
          <div id="tabs" class="flex justify-around">

            <div v-bind:class="{'hidden': !contactDropdownPopoverShow, 'block': contactDropdownPopoverShow}" class="bg-white text-base z-50 float-left py-2 list-none text-left rounded shadow-lg mb-1" ref="popoverContactRef">
                
                <a href="https://www.instagram.com/pnadi.app"  
                class="hover:bg-pink-600 text-sm py-2 px-4 font-normal block whitespace-no-wrap bg-transparent  text-gray-800">

                <img src="@/assets/images/instagram-icon.png" class="rounded-full p-1 lg:p-3 object-contain h-8 w-8 lg:h-16 lg:w-16"/>

                  <!-- <span class="tab tab-explore block text-xs"><p>Instagram</p></span> -->

                </a>
                
                <a :href="`https://wa.me/0096599003047`" 
                class="hover:bg-pink-600 text-sm py-2 px-4 font-normal block whitespace-no-wrap bg-transparent  text-gray-800">
                
                    <img src="@/assets/images/whatsapp.png" class="rounded-full p-1 lg:p-3 object-contain h-8 w-8 lg:h-16 lg:w-16"/>

                    <!-- <span class="tab tab-explore block text-xs"><p>Whatsapp</p></span> -->
                </a>

                <a :href="`mailto: pnadi@pnadi.com`"  
                class="hover:bg-pink-600 text-sm py-2 px-4 font-normal block whitespace-no-wrap bg-transparent  text-gray-800">
                    
                    <img src="@/assets/images/mail.png" class="rounded-full p-1 lg:p-3 object-contain h-8 w-8 lg:h-16 lg:w-16"/>

                    <!-- <span class="tab tab-explore block text-xs"><p>Email</p></span> -->
                </a>
                
                <div class="h-0 my-2 border border-solid border-t-0 border-gray-900 opacity-25"></div>

                <a :href="`tel:0096599003047`" class="hover:bg-pink-600 text-sm py-2 px-4 font-normal block whitespace-no-wrap bg-transparent  text-gray-800">
                    
                    <img src="@/assets/images/call-icon.svg" class="rounded-full p-1 lg:p-3 object-contain h-8 w-8 lg:h-16 lg:w-16"/>

                    <!-- <span class="tab tab-explore block text-xs"><p>Call</p></span> -->
                </a>
            </div>

            <div v-bind:class="{'hidden': !layoutTypePopOverShow, 'block': layoutTypePopOverShow}" class="bg-white text-base z-50 float-left py-2 list-none text-left rounded shadow-lg mb-1" ref="popoverLayoutRef">
            
                <a @click="action_2(2)"  
                class="hover:bg-pink-600 text-sm py-2 px-4 font-normal block whitespace-no-wrap bg-transparent  text-gray-800">
                    
                    <img src="@/assets/images/pitch-icon.svg" class="rounded-full p-1 lg:p-3 object-contain h-8 w-8 lg:h-16 lg:w-16"/>

                    <!-- <span class="tab tab-explore block text-xs"><p>Email</p></span> -->
                </a>
                
                <a @click="action_2(1)"
                class="hover:bg-pink-600 text-sm py-2 px-4 font-normal block whitespace-no-wrap bg-transparent  text-gray-800">
                
                    <img src="@/assets/images/fitness-icon.svg" class="rounded-full p-1 lg:p-3 object-contain h-8 w-8 lg:h-16 lg:w-16"/>

                    <!-- <span class="tab tab-explore block text-xs"><p>Whatsapp</p></span> -->
                </a>


            </div>

            <!-- <div v-if ="$countryCode == 'KW'" class="flex flex-col items-center"> -->
                <div class="flex flex-col items-center">

              <a href="#" class="justify-center inline-block text-center pt-2 pb-1" @click="switchLocal"
                :class="{'my-main-footer-link': isPinkStyle , 'my-light-footer-link': !isPinkStyle}">

                <img src="@/assets/images/language-icon.svg" class="rounded-full p-1 lg:p-3 object-contain h-8 w-8 lg:h-16 lg:w-16"/>

                  <span class="tab tab-account block text-xs">{{ this.$t('footer.language')}}</span>
              </a>

              </div>
            
            <div class="flex flex-col items-center"  ref="contactBtnDropdownRef">

              <!-- <a href="https://www.instagram.com/pnadi.app"  -->
              <!-- <a
              class="flex flex-col justify-center items-center focus:bg-pink-600 hover:bg-pink-600 justify-center inline-block text-center pt-2 pb-1"> -->
                
              <a @click="toggleContactDropdown"
              class="flex flex-col justify-center items-center inline-block text-center pt-2 pb-1"              
            :class="{'my-main-footer-link': isPinkStyle , 'my-light-footer-link': !isPinkStyle}">

                <img src="@/assets/images/contact-icon.svg" class="rounded-full p-1 lg:p-3 object-contain h-8 w-8 lg:h-16 lg:w-16"/>

                  <span class="tab tab-explore block text-xs"><p>{{$t('footer.contact')}}</p></span>
              </a>
            </div>


            <div class="flex flex-col justify-center items-center" ref="layoutBtnDropdownRef">

              <a @click="toggleLayoutDropdown"
            :disabled="true" class="flex flex-col justify-center items-center inline-block text-center pt-2 pb-1"
            :class="{'my-main-footer-link': isPinkStyle , 'my-light-footer-link': !isPinkStyle}">

                    <!-- <img src="@/assets/images/style-icon.svg" class="rounded-full p-1 lg:p-3 object-contain h-8 w-8 lg:h-16 lg:w-16"/> -->
                    <img src="@/assets/images/only-logo.jpg" class="rounded-full p-1 lg:p-3 object-contain h-8 w-8 lg:h-16 lg:w-16"/>

                  <span class="tab tab-account block text-xs">{{$t('footer.goTo')}}</span>
              </a>

            </div>

            <div class="flex flex-col items-center">
              <a href="#" class="flex flex-col justify-center items-center inline-block text-center pt-2 pb-1" @click="action_3"
                :class="{'my-main-footer-link': isPinkStyle , 'my-light-footer-link': !isPinkStyle}">


                    <img src="@/assets/images/reset-icon.svg" class="rounded-full p-1 lg:p-3 object-contain h-8 w-8 lg:h-16 lg:w-16"/>

                  <span class="tab tab-account block text-xs">{{ this.$t('footer.reset')}}</span>
              </a>
            </div>
          </div>
      </section>
      
    </footer>
</template>

<script>

import Vue from 'vue';
import componentHelpers from '../classes/componentHelpers';

import { createPopper } from '@popperjs/core';

export default {

    created(){

        if(localStorage.hasOwnProperty('pickedLayout')){

            const val = localStorage.getItem('pickedLayout'); 

            // this.switchLayout(val);
        }
    },

    mounted(){

        let storedLocal;
        
        if(localStorage.hasOwnProperty('localLangauge')){

             storedLocal = localStorage.getItem('localLangauge');

                if(storedLocal == 'ar'){

                    this.languageTitle = 'English';
                }else{

                    storedLocal = 'en';

                    this.languageTitle = 'Arabic';
                }
            
            this.$i18n.locale = storedLocal;

        }else{

            this.$i18n.locale = 'en';


            this.languageTitle = 'Arabic';

            localStorage.setItem('localLangauge', 'en');
        }

        document.dir = this.$i18n.locale == "ar" ? "rtl" : "ltr"


        this.setStyle();
    },

    props: {

        items: 0,

        name_1: '',

        name_2: '',

        name_3: '',

        action_1: {

            type: Function
        },

        action_2: {

            type: Function
        },

        action_3: {

            type: Function
        },
    },

    methods:{

        toggleContactDropdown(){
            
            const test = new createPopper();


            if(this.contactDropdownPopoverShow){
                this.contactDropdownPopoverShow = false;
            } else {
                this.contactDropdownPopoverShow = true;
                new createPopper(this.$refs.contactBtnDropdownRef, this.$refs.popoverContactRef, {
                placement: "top"
                });
            }
        },


        toggleLayoutDropdown(){
            
            // componentHelpers.toastIt(this.$toasted, this.$t('home.comingSoonToast'), 1, 'outline', true);

            // return;
            
            const test = new createPopper();


            if(this.layoutTypePopOverShow){

                this.layoutTypePopOverShow = false;
            } else {

                this.layoutTypePopOverShow = true;
                new createPopper(this.$refs.layoutBtnDropdownRef, this.$refs.popoverLayoutRef, {
                placement: "top"
                });
            }
        },

        // switchLayout(val){

        //     this.layoutTypePopOverShow = false;

        //     if(val == 2){

        //         componentHelpers.toastIt(this.$toasted, this.$t('home.comingSoonToast'), 1, 'outline', true);

        //         return;
        //     }
        //     else if(val == 1){

        //         this.$layoutType = val;

        //         localStorage.setItem('pickedLayout', val);
                
        //         // this.$router.replace({ path: 'sessions'});

        //         this.$router.push('sessions');
        //     }
        //     else{

        //         this.$layoutType = val;

        //         localStorage.setItem('pickedLayout', val);
                
        //         // this.$router.replace({ path: '/home'});

        //         this.$router.push('home');
        //     }
        // },

        switchLocal(){
            
            let storedLocal;

            if(localStorage.hasOwnProperty('localLangauge')){

                // console.log(`localStorage Local: ${localStorage.getItem('localLangauge')}`);

                storedLocal = localStorage.getItem('localLangauge');

                if(storedLocal == 'ar'){

                    storedLocal = 'en';

                    this.languageTitle = 'Arabic';

                    localStorage.setItem('localLangauge', storedLocal);
                }else{

                    storedLocal = 'ar';

                    this.languageTitle = 'English';

                    localStorage.setItem('localLangauge', storedLocal);
                }
            }else{

                storedLocal = 'en';

                this.languageTitle = 'Arabic';

                localStorage.setItem('localLangauge', storedLocal);
            }


            this.$i18n.locale = storedLocal;

            document.dir = this.$i18n.locale == "ar" ? "rtl" : "ltr"

            this.setStyle();
            // console.log(`local is: ${storedLocal}`);

            // if(this.$i18n.locale != locale){

            //     this.$i18n.locale = locale;
            // }
        },

        setStyle(){

            let myStyle;
        
            if(localStorage.hasOwnProperty('myStyle')){

                myStyle = localStorage.getItem('myStyle');

                if(myStyle == 'pink'){

                this.styleTitle = this.$t('footer.platform');
                }else{

            this.styleTitle = this.$t('footer.colorfulTheme');
                }
            }

            this.$myStyle = myStyle;
        },


        switchStyle(){

            componentHelpers.toastIt(this.$toasted, this.$t('home.comingSoonToast'), 1, 'bubble', false);

            return;

            let myStyle;

            if(localStorage.hasOwnProperty('myStyle')){

                // console.log(`footer myStyle: ${localStorage.getItem('myStyle')}`);

                myStyle = localStorage.getItem('myStyle');

                if(myStyle == 'pink'){

                    myStyle = 'light';

                    this.styleTitle = this.$t('footer.colorfulTheme');

                    this.$isPinkStyle = false;

                    localStorage.setItem('myStyle', myStyle);
                }else{

                    myStyle = 'pink';

                    this.styleTitle = this.$t('footer.lightTheme');

                    this.$isPinkStyle = true;

                    localStorage.setItem('myStyle', myStyle);
                }
            }else{

                myStyle = 'light';

                this.styleTitle = this.$t('footer.colorfulTheme');

                this.$isPinkStyle = false;   

                localStorage.setItem('myStyle', myStyle);
            }

            // this.$myStyle = myStyle;

            // location.reload(true);
                // console.log(`isPinkStyle: ${this.$isPinkStyle}`);

            // }
        }
    },

    data: function (){

        return {

            languageTitle: this.$i18n.locale == 'en' ? 'Arabic': 'English',
            styleTitle: 'Light Theme',
            isPinkStyle: true,
            contactDropdownPopoverShow: false,
            layoutTypePopOverShow: false,

        }
    },


   watch: {

        '$isPinkStyle'(newValue) {

        console.log(`from app: newvalue: ${newValue}`);
            
            this.isPinkStyle = newValue;

            // console.log(`in Watcehr: pink is ${newValue}`);
            }
        }
}
</script>

<style>

</style>